'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FrownOutlined = _interopRequireDefault(require('./lib/icons/FrownOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _FrownOutlined;
  exports.default = _default;
  module.exports = _default;